import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPaperPlane } from 'react-icons/fa';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '', // Agregamos el campo de teléfono
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setMessageType('');

    const lambdaUrl = 'https://3gpqwxbf45nkhnhucubmfpzddu0empec.lambda-url.us-east-1.on.aws/';
    
    const payload = {
      site: "asesoriaseguridadsocial.com.co",
      siteEmail: "no-reply@asesoriaseguridadsocial.com.co", // Puedes cambiar esto si tienes un dominio de correo configurado en SES
      recibeEmail: "consultorias.legal@gmail.com",
      userName: formData.name,
      userPhone: formData.phone,
      userEmail: formData.email,
      userMessage: formData.message
    };

    try {
      const response = await fetch(lambdaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSubmitMessage('¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.');
        setMessageType('success');
        setFormData({ name: '', email: '', phone: '', message: '' }); // Limpiar el formulario
      } else {
        const errorData = await response.json();
        setSubmitMessage(`Error al enviar el mensaje: ${errorData.message || 'Inténtalo de nuevo más tarde.'}`);
        setMessageType('error');
      }
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      setSubmitMessage('Hubo un problema de conexión. Por favor, inténtalo de nuevo más tarde.');
      setMessageType('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputClasses = "w-full px-4 py-3 rounded-lg bg-gray-100 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 text-gray-800 placeholder-gray-500";
  const labelClasses = "block text-gray-700 text-sm font-semibold mb-2";

  return (
    <motion.section
      className="py-16 bg-gradient-to-br from-gray-50 to-gray-100"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <div className="container mx-auto px-4 max-w-2xl">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-10"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          ¿Tienes Preguntas? ¡Contáctanos!
        </motion.h2>

        <motion.form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-xl shadow-2xl border border-gray-200"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.6 }}
        >
          <div className="mb-6">
            <label htmlFor="name" className={labelClasses}>
              Tu Nombre
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={inputClasses}
              placeholder="Ej: Juan Pérez"
              required
            />
          </div>

          <div className="mb-6">
            <label htmlFor="email" className={labelClasses}>
              Tu Correo Electrónico
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={inputClasses}
              placeholder="Ej: tu.correo@ejemplo.com"
              required
            />
          </div>

          <div className="mb-6">
            <label htmlFor="phone" className={labelClasses}>
              Tu Teléfono
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={inputClasses}
              placeholder="Ej: +57 310 1234567"
              required
            />
          </div>

          <div className="mb-8">
            <label htmlFor="message" className={labelClasses}>
              Tu Mensaje
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              className={`${inputClasses} resize-y`}
              placeholder="Escribe tu consulta aquí..."
              required
            ></textarea>
          </div>

          <motion.button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-3 px-6 rounded-lg shadow-lg flex items-center justify-center transition duration-300 ease-in-out transform ${
              isSubmitting
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-gradient-to-r from-blue-600 to-purple-700 text-white hover:scale-105 hover:from-blue-700 hover:to-purple-800'
            }`}
            whileHover={isSubmitting ? {} : { scale: 1.05 }}
            whileTap={isSubmitting ? {} : { scale: 0.95 }}
          >
            {isSubmitting ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Enviando...
              </>
            ) : (
              <>
                <FaPaperPlane className="mr-3 text-xl" />
                Enviar Mensaje
              </>
            )}
          </motion.button>

          {submitMessage && (
            <motion.p
              className={`mt-4 text-center font-semibold ${
                messageType === 'success' ? 'text-green-600' : 'text-red-600'
              }`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {submitMessage}
            </motion.p>
          )}
        </motion.form>
      </div>
    </motion.section>
  );
};

export default ContactForm;